












import { Vue, Component, Prop } from 'nuxt-property-decorator';
import UniversalSearchResultsItem from '@/components/common/UniversalSearch/UniversalSearchResults/UniversalSearchResultsItem.vue';
import BravadoEmptyPlaceholder from '@/components/common/BravadoEmptyPlaceholder/BravadoEmptyPlaceholder.vue';

@Component<UniversalSearchResultsLoader>({
  components: {
    UniversalSearchResultsItem,
    BravadoEmptyPlaceholder,
  },
})
export default class UniversalSearchResultsLoader extends Vue {
  @Prop({ default: 5 }) items!: number;
}
